import React, { useEffect, useState } from 'react';
import { CenaIcon } from '../components/MenuIcons';
import { getDatabase, Question } from './PollSystemDatabase';

interface getPollQuestionsReturn {
  title: string;
  choices: string[];
  bgImg: string;
}

// export const getPollQuestions = (qid: number): getPollQuestionsReturn | null => {
//   const question = database.find((q) => q.id === qid);
//   if (question == null) {
//     return null;
//   }
//   return {
//     title: question.title,
//     choices: question.answers.map((ans) => ans.answer),
//     bgImg: question.bgImg,
//   };
// };

interface AnkietaContextInterface {
  answers: boolean[][];
  changeAnswer: (qid: any, aid: any, newVal: boolean) => void;
  getAnswer: (qid: any, aid: any) => boolean;
  findBestProduct: () => string[];
  findSuggestedProducts: () => string[];
  resetAnswers: (toThatQid: number) => void;
  getPollQuestions: (qid: number) => getPollQuestionsReturn | null;
  savePollData: () => void;
}

export const AnkietaContext = React.createContext<AnkietaContextInterface>({
  answers: [],
  changeAnswer: (qid, aid, newVal) => {
    console.log(`${qid} ${aid} to ${newVal}`);
  },
  getAnswer: (qid, aid) => false,
  findBestProduct: () => [],
  findSuggestedProducts: () => [],
  resetAnswers: (toThatQid: number) => {},
  getPollQuestions: (qid: number) => null,
  savePollData: () => null,
});

export const AnkietaContextProvider = ({ children }: { children: any }) => {
  const [answers, setAnswers] = useState<boolean[][]>(defaultAnswerMatrix([]));
  const [database, setDatabase] = useState<Question[]>([]);

  useEffect(() => {
    // load database from API
    getDatabase().then((data) => {
      console.log('ZAŁADOWANO BAZE PYTAŃ');
      setDatabase(data);
      setAnswers(defaultAnswerMatrix(data));
    });
  }, []);

  function defaultAnswerMatrix(database: Question[]): boolean[][] {
    let out: boolean[][] = [];
    database.forEach((question) => {
      out.push(question.answers.map(() => false));
    });
    return out;
  }

  const getAnswer = (qid: number, aid: number) => answers[qid - 1][aid];

  const resetAnswers = (toThatQid: number) => {
    if(toThatQid == 6){
      // Nie resetuj jeżeli wyświetlasz stronę z galerią (podglądem produktów)
      return;
    }
    if (toThatQid != -1) {
      let newAnswers = answers;
      // usuń wszystkie odpowiedzi do toThatQid
      for (let qid = newAnswers.length - 1; qid >= toThatQid; qid--) {
        let liczbaOdpowiedziWPytaniu = newAnswers[qid].length;
        newAnswers[qid] = [];
        for (let i = 0; i < liczbaOdpowiedziWPytaniu; i++) {
          newAnswers[qid].push(false);
        }
      }
      setAnswers(newAnswers);

      // regenerate product glow
      glowUpdate();
      return;
    }
    setAnswers(defaultAnswerMatrix(database));
  };

  function glowUpdate() {
    const bestList = findBestProduct();
    console.log(`glowUpdate, Glow ${bestList.length} elements`);
    fetch('/api/v1/product_glow/', {
      method: 'POST',
      body: JSON.stringify(bestList.length == 0 ? ['all_shadow'] : bestList),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
  }

  const changeAnswer = (qid: number, aid: number, newVal: boolean) => {
    let edit = answers;
    edit[qid - 1][aid] = newVal;
    setAnswers(edit);
    if (JSON.stringify(edit) == JSON.stringify(defaultAnswerMatrix(database))) {
      console.log('Usuwam podswietlenia wszystkiego');
      fetch('/api/v1/product_glow/', {
        method: 'POST',
        body: JSON.stringify(['all_shadow']),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      });
    } else {
      glowUpdate();
    }
  };

  const getEanCodesForQuestion = (qid: number, answerList: boolean[]) => {
    let ean_codes: string[] = [];
    const queston = database.find((q) => q.id == qid);
    queston?.answers.forEach((a, aid) => {
      if (answerList[aid] == true) {
        ean_codes = ean_codes.concat(a.eanCodeList);
      }
    });
    return ean_codes;
  };

  const findBestProductList = (answersMapFiltred: boolean[][]) => {
    let ean_codesList: string[] = [];
    const answers_eanList = answersMapFiltred.map((boolAnswersList, questionid) =>
      getEanCodesForQuestion(questionid + 1, boolAnswersList)
    );

    let flip = true;
    answers_eanList.forEach((eanList) => {
      if (eanList.length == 0) return;
      if (ean_codesList.length == 0 && flip) {
        flip = false;
        ean_codesList = eanList;
        return;
      }
      ean_codesList = ean_codesList.filter(function (val) {
        return eanList.indexOf(val) != -1;
      });
    });
    const uniqueEanCodesList = ean_codesList.filter(function (item, pos) {
      return ean_codesList.indexOf(item) == pos;
    });

    return uniqueEanCodesList;
  };

  const findBestProduct = () => {
    // Produkty które pasują do odpowiedzi klienta
    return findBestProductList(answers);
  };

  const findSuggestedProducts = () => {
    // wyszukowanie produktów ale pomijanie niektórych
    const answersButSkipQuestions = (idList: Number[]) => {
      return answers.map((e, i) => {
        if (idList.includes(i)) {
          return e.map((f) => true);
        }
        return e;
      });
    };

    const ean_codesListAll = findBestProductList(answers);
    if (ean_codesListAll.length != 0) return ean_codesListAll;

    /*
    0. kolor
    1. Wytrawność
    2. Cena
    3. Okazja
    4. Kraj

    kraj < okazja < cena < wytrawność < kolor
    4 < 3 < 2 < 1 < 0
    */

    const bezKraju = findBestProductList(answersButSkipQuestions([4]));
    if (bezKraju.length >= 5) return bezKraju;

    const bezOkazji = findBestProductList(answersButSkipQuestions([4, 3]));
    if (bezOkazji.length >= 5) return bezOkazji;

    const bezCeny = findBestProductList(answersButSkipQuestions([4, 3, 2]));
    if (bezCeny.length >= 5) return bezCeny;

    const bezWytrawno = findBestProductList(answersButSkipQuestions([4, 3, 2, 1]));
    if (bezWytrawno.length >= 5) return bezWytrawno;

    const bezKoloru= findBestProductList(answersButSkipQuestions([4, 3, 2, 1, 0]));
    if (bezKoloru.length >= 5) return bezKoloru;

    // bez wszystkiego
    return findBestProductList(answersButSkipQuestions([0, 1, 2, 3, 4, 5]));
  }

  const getPollQuestions = (qid: number) => {
    const question = database.find((q) => q.id === qid);
    if (question == null) {
      return null;
    }
    return {
      title: question.title,
      choices: question.answers.map((ans) => ans.answer),
      bgImg: question.bgImg,
    };
  };

  const savePollData = () => {
    const answersStr = answers.map((v, i) => getPollQuestions(i + 1));

    const yourAnswers = answers.map((v, i) => {
      return {
        choices: v.map((a, ia) => (a ? answersStr[i]?.choices[ia] : null)).filter((x) => x !== null),
        title: answersStr[i]?.title,
      }
    })

    fetch('/api/v1/pollanalytics/', {
      method: 'POST',
      body: JSON.stringify({
        answers: yourAnswers,
        ean_codes: findBestProduct(),
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
  };

  return (
    <AnkietaContext.Provider
      value={{ answers, getAnswer, resetAnswers, changeAnswer, findBestProduct, findSuggestedProducts, getPollQuestions, savePollData }}
    >
      {children}
    </AnkietaContext.Provider>
  );
};
